<section id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <app-minimalist-entry>
        <div slot="content">
          <form class="form-login" [formGroup]="form" spellcheck="false">
            <div class="form-inner-group input-group password">
              <input
                formControlName="password"
                type="password"
                class="form-control"
                i18n-placeholder="new password placeholder|The placeholder that is visible at new password input for a user password change before a content is written to it@@newPasswordPlaceholder"
                placeholder="New Password"
                autocomplete="new-password"
                [readonly]="loading || successfullySent"
                spellcheck="false"
                autofocus
                required
              >
            </div>
            <div class="form-inner-group input-group confirm-password">
              <input
                formControlName="passwordConfirm"
                type="password"
                class="form-control"
                i18n-placeholder="confirm password placeholder|The placeholder that is visible at an password confirmation input before a content is written to it@@confirmPasswordPlaceholder"
                placeholder="Confirm password"
                autocomplete="new-password"
                [readonly]="loading || successfullySent"
                spellcheck="false"
                autofocus
                required
              >
            </div>
            <div class="form-inner-group alert-wrapper" *ngIf="(attemptedSubmit && form.invalid && form.dirty)">
              <div *ngIf="(form.invalid && form.dirty)">
                <ul class="alert alert-danger">
                  <li *ngIf="password.invalid && password.errors.minlength">
                    <span i18n="new password too small starting text|The starting part (prefix) of the error message shown when the new password does not contain the minimum character length@@newPasswordIncorrectLengthErrorStart">The password must have</span>
                    <span> </span><span>{{ password.errors.minlength.requiredLength }}</span><span> </span>
                    <span i18n="new password too small middle text|The middle part of the error message shown when the new password does not contain the minimum character length@@newPasswordIncorrectLengthErrorMiddle">characters, but there's only</span><span> </span><span>{{ password.errors.minlength.actualLength }}</span>
                  </li>
                  <li
                    *ngIf="password.invalid && password.errors.required"
                    i18n="password is required|Error message for when the password is missing or invalid@@passwordRequired"
                  >The password is required</li>
                  <li
                    *ngIf="!password.invalid"
                    i18n="passwords doesnt match|Error message for when the password and a confirmation of the password does not match@@passwordMatchRequired"
                  >The passwords don't match</li>
                </ul>
              </div>
            </div>
            <div class="form-inner-group alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
            <div
              class="form-inner-group alert alert-success"
              *ngIf="successfullySent"
              i18n="password successfully changed after reset message|Message shown to authenticated users once they successfully set a new password@@passwordChangeSuccessInternally"
            >Your password has been successfully changed. You can login with the new password from now on.</div>
            <div class="form-inner-group actions">
              <button type="submit" class="btn btn-theme btn-block login btn-with-left-icon" (click)="onSubmitClick()" [disabled]="successfullySent">
                <i *ngIf="!loading" class="fa fa-key"></i>
                <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin"></i>
                <span
                  *ngIf="successfullySent"
                  i18n="successfull register button label|The main submit button label for the account register form page once the user successfully creates his account@@successfullRegisterButtonLabel"
                >Done!</span>
                <span
                  *ngIf="!successfullySent"
                  i18n="register button label|The main submit button label for the account register form page@@registerButtonLabel"
                >Register</span>
              </button>
            </div>
          </form>
        </div>
      </app-minimalist-entry>
    </section>
  </section>
</section>
